import { useAppDispatch, useAppSelector } from '@/redux/global-hooks';
import {
  clearEditingTopic,
  clearEditingTopicAnswer,
  selectTopic,
  setEditingTopic,
  setEditingTopicAnswer,
} from '@/redux/slices/topic.slice';

export default function useTopic() {
  const dispatch = useAppDispatch();
  const topic = useAppSelector(selectTopic);

  const setEditingTopicValues = (values) => dispatch(setEditingTopic(values));
  const clearEditingTopicValues = () => dispatch(clearEditingTopic());
  const setEditingTopicAnswerValues = (values) => dispatch(setEditingTopicAnswer(values));
  const clearEditingTopicAnswerValues = () => dispatch(clearEditingTopicAnswer());

  return {
    topic,
    setEditingTopicValues,
    clearEditingTopicValues,
    setEditingTopicAnswerValues,
    clearEditingTopicAnswerValues,
  };
}
